export enum ReleaseMode {
  Rolling = 'Rolling Results',
  unreachableFutureDate = '3000-01-01T00:00:00Z'
}

function isRollingRelease (value: any): value is ReleaseMode {
  return value === ReleaseMode.Rolling
}

export function parseReleaseTimestamp (value: unknown): Date | null {
  if (isRollingRelease(value)) {
    // Assign a far-future date to represent 'Rolling Release'
    return new Date(ReleaseMode.unreachableFutureDate)
  }

  const parsedDate = new Date(value as string)
  return isNaN(parsedDate.getTime()) ? null : parsedDate
}
